export interface FrontStatEvent {
    type: 'hit' | 'reachGoal';
    timestamp: number;
    url?: string;
    goal?: string;
    params?: object;
}

const queue: FrontStatEvent[] = [];

export function pushEvent(event: FrontStatEvent) {
    queue.push(event);
}

export function flushQueue(): FrontStatEvent[] {
    return queue.splice(0, queue.length);
}
